import styled from 'styled-components';
import { gray20, gray45, gray95, spacer4, spacer8, screenXsMax } from '@spotify-internal/encore-foundation';
import Type from "../Type";
export default styled(Type).attrs({
  variant: Type.body3
}).withConfig({
  displayName: "Legal",
  componentId: "de5ili-0"
})(["background:", ";border-radius:", ";color:", ";display:", ";max-width:100%;padding:", ";a{margin-left:0;}a[href]:not([class]){color:inherit;margin:0;&:hover{color:", ";}&:active,&:focus{color:", ";}}@media (max-width:", "){display:block;}"], gray95, spacer4, gray45, function (props) {
  return props.legalStrict ? 'block' : 'inline-block';
}, spacer8, gray20, gray45, screenXsMax);